"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.64 10"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.2,9.39V2.09L1.06,3.21a.63.63,0,0,1-.88,0,.6.6,0,0,1,0-.86L2.38.18a.63.63,0,0,1,.88,0l2.2,2.17a.59.59,0,0,1,0,.86.63.63,0,0,1-.88,0L3.44,2.09v7.3a.61.61,0,0,1-.62.61A.61.61,0,0,1,2.2,9.39Z"
  }));
};

exports["default"] = _default;